// pages/Register.jsx
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api';
import Footer from '../components/Footer';

const Register = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const preselectedRole = location.state?.preselectedRole || 'particulier'; // Default to 'particulier'

  const [role] = useState(preselectedRole);

  // Remove the redirect, as we default to 'particulier'

  const [form, setForm] = useState({
    name: '',
    prenom: '',
    email: '',
    password: '',
    role// ← rôle forcé par le bouton cliqué
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await api.post('/api/auth/register', form);

    // ✅ Affiche le message de succès
    alert('Inscription réussie ! Un email de vérification a été envoyé. Veuillez vérifier votre email avant de vous connecter.');

    // ✅ Redirige vers la page de connexion
    navigate('/login');
  } catch (err) {
    alert(err.response?.data?.msg || 'Erreur lors de l’inscription');
  }
};

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--app-background)' }}>
      <header className="p-4 text-center border-b bg-white">
        <button onClick={() => navigate(-1)} className="link-fuchsia">
          ← Retour
        </button>
      </header>

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Inscription {form.role === 'createur' ? 'Créateur' : 'Particulier'}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Plus de choix de rôle ici ! */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="Nom"
                value={form.name}
                onChange={handleChange}
                required
                className="border border-gray-300 rounded-lg px-4 py-3"
              />
              <input
                type="text"
                name="prenom"
                placeholder="Prénom"
                value={form.prenom}
                onChange={handleChange}
                required
                className="border border-gray-300 rounded-lg px-4 py-3"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
                className="border border-gray-300 rounded-lg px-4 py-3"
              />
              <input
                type="password"
                name="password"
                placeholder="Mot de passe"
                value={form.password}
                onChange={handleChange}
                required
                className="border border-gray-300 rounded-lg px-4 py-3"
              />
            </div>

            <button
              type="submit"
              className="w-full btn-primary py-3 font-semibold"
            >
              S'inscrire
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Register;
